import React, { Component } from "react";
import withFindLocations from "./FindLocation/with_find_location";
import { isRecaptchaEnabled } from "../captcha";

const FindLocation = withFindLocations(({ content }) => (
	<form className="bl-form">{content}</form>
));

class SearchBusiness extends Component {
	// Autocomplete and Place Details are proxied through the plugin backend,
	// so this component needs no Google key.
	select = business => {
		const { onSelect } = this.props;
		onSelect(business);
	};

	render() {
		const { isSearchDisabled, onOpenPopup } = this.props;

		return (
			<div className="idg-search-business ">
				<div className="idg-search-row idg-animate-me">
					<FindLocation
						googleMapsCountries={[]}
						onSelectLocation={this.select}
						onFocus={isSearchDisabled ? onOpenPopup : () => false}
					/>
				</div>
				{isRecaptchaEnabled() && (
					<p className="idg-recaptcha-notice idg-animate-me">
						This site is protected by reCAPTCHA and the Google{" "}
						<a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and{" "}
						<a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> apply.
					</p>
				)}
				<p className="idg-search-warning idg-animate-me">
					<span className="bold">Please note:</span> if the business has hidden its address in its Google Business Profile listing, you will not be able to generate Google links and
					IDs using this tool. We use the Google Places API to locate the
					business and this API does not include businesses with hidden
					addresses.
				</p>
			</div>
		);
	}
}

export default SearchBusiness;
